// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KUYE","questions":"styles_questions__39GBX","footer":"styles_footer__1x45s"};